<div class="f-row f-center h-inherit">
    <div #origin class="col" [class.col--disabled]="isLocationPanelOpen" (click)="showLocationPanel(origin)">
        <div class="box-element startIn-box">
            @if (trip().isPlanningTripLocation) {
                <div class="box-element--label">
                    Start at:
                    <input
                            readonly
                            type="text"
                            placeholder="City, Country"
                            [value]="trip().startingLabel"
                    />
                </div>
                @if (trip().endingLabel) {
                    <div class="box-element--label">
                        End at:
                        <input
                                readonly
                                type="text"
                                [value]="trip().endingLabel"
                                placeholder="City, Country"
                        />
                    </div>
                }
                @if (!trip().startingLabel) {
                    <div class="f-row f-v-center startIn-box-placeholder box-element--label">
                        Where do you want to go?
                    </div>
                }
            } @else {
                @if (trip().cityInfo) {
                    <div class="box-element--label box-element--full">
                        City:
                        <input
                                readonly
                                type="text"
                                [value]="trip().cityInfo.label"
                                placeholder="City, Country"
                        />
                    </div>
                } @else {
                    <div class="f-row f-v-center startIn-box-placeholder box-element--label">
                        Where do you want to go?
                    </div>
                }
            }
        </div>
    </div>
    <div class="col">
        <button #dateRef class="box-element duration-box f-row f-between" (click)="showDurationPanel(dateRef)">
            <div class="box-element--label">
                {{ trip() | durationTransformer }}
            </div>
            <mat-icon
                    class="angle-icon"
                    [svgIcon]="eSvgIcons.ANGLE_DOWN"
            ></mat-icon>
        </button>
    </div>
    <div class="col">
        <button
                class="box-element duration-box f-row f-between"
                #travellersRef
                (click)="showTravelersPanel(travellersRef)"
        >
            <div class="box-element--label">
                Travelers: <span>{{ trip().rooms | travellersTransformer }}</span>
            </div>
            <mat-icon
                    class="angle-icon"
                    [svgIcon]="eSvgIcons.ANGLE_DOWN"
            ></mat-icon>
        </button>
    </div>
    <button class="btn-dark btn-start" (click)="navigateToTripPlanner(origin, true)">
        {{ mode === 'standalone' ? "Start Planning" : "Create new Trip" }}
    </button>
</div>
